const editorConfig = {
  options: [
    "inline",
    "blockType",
    "fontSize",
    "list",
    "textAlign",
    "link",
    "emoji",
  ],
  inline: {
    options: ["bold", "italic", "underline", "strikethrough"],
  },
};

export default editorConfig;
